/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 51036:
/***/ ((module) => {

module.exports = "../../app/cells/components/handle_title_segment/show.erb";

/***/ }),

/***/ 27310:
/***/ ((module) => {

module.exports = "../../app/cells/components/handle_title_segment_cell.rb";

/***/ }),

/***/ 44823:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./pages/institutes/components/institute_item/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/institutes/components/institute_item/index.js


// EXTERNAL MODULE: ./utils/filter_form/index.js
var filter_form = __webpack_require__(65917);
// EXTERNAL MODULE: ./utils/autofill_by_query_string/index.js
var autofill_by_query_string = __webpack_require__(19682);
// EXTERNAL MODULE: ./components/select/index.js + 9 modules
var components_select = __webpack_require__(86325);
// EXTERNAL MODULE: ./components/alphabetical_input/index.js
var alphabetical_input = __webpack_require__(6857);
;// CONCATENATED MODULE: ./pages/institutes/components/institutes_filter_form/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/institutes/components/institutes_filter_form/index.js





(function($) {
    const $filterForm = $('#js-institutes-filter-form');
    $filterForm.autoFillByQueryString().filterForm().lazyReady();
// $filterForm.on('submit', () => {
//   $filterForm.trigger('filterFormToggle');
//   return false;
// });
})(window.jQuery);

;// CONCATENATED MODULE: ./pages/institutes/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./components/featured_appendix_item/index.js + 1 modules
var featured_appendix_item = __webpack_require__(89783);
// EXTERNAL MODULE: ./components/handle_title_segment/index.erb
var handle_title_segment = __webpack_require__(51036);
// EXTERNAL MODULE: ./components/handle_title_segment/index.rb
var components_handle_title_segment = __webpack_require__(27310);
;// CONCATENATED MODULE: ./components/handle_title_segment/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/handle_title_segment/index.js



const segmentsPath = [
    'questoes-de-concursos',
    'questoes-militares',
    'questoes-da-oab',
    'questoes-do-enem',
    'questoes-de-vestibular'
];
const segmentsName = {
    'questoes-de-concursos': 'Concursos',
    'questoes-militares': 'Militares',
    'questoes-da-oab': 'OAB',
    'questoes-do-enem': 'ENEM',
    'questoes-de-vestibular': 'Vestibular'
};
class HandleTitleSegment {
    init() {
        this.activateSegmentButton();
        this.addClickEventToButtons();
        this.redirectToSegment();
        this.toggleModal();
    }
    toggleModal() {
        this.$toogleModalButtons.on('click', ()=>{
            if (this.$modal.hasClass('hidden')) {
                this.openModal();
                return;
            }
            this.closeModal();
        });
    }
    openModal() {
        this.$modal.removeClass('hidden');
        window.jQuery('body').addClass('q-select-no-scroll');
    }
    closeModal() {
        this.$modal.addClass('hidden');
        this.setToInitialSegment();
        window.jQuery('body').removeClass('q-select-no-scroll');
    }
    setBaseUrl() {
        const url = new URL(window.location.href);
        return url.origin;
    }
    hasSegment() {
        const url = new URL(window.location.href);
        const segment = url.pathname.split('/')[1];
        if (segmentsPath.includes(segment)) {
            return segment;
        } else {
            return null;
        }
    }
    pathnameWithoutSegment() {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/').filter((part)=>part && !segmentsPath.includes(part));
        return '/' + pathParts.join('/');
    }
    activateSegmentButton() {
        this.$buttons.each((i, button)=>{
            const $button = window.jQuery(button);
            if ($button.data('segment') === this.dynamicSegment) {
                $button.addClass('active');
            } else {
                $button.removeClass('active');
            }
        });
    }
    addClickEventToButtons() {
        this.$buttons.on('click', (event)=>{
            const $button = window.jQuery(event.target);
            const segment = $button.data('segment');
            this.handleButtonClick(segment);
        });
    }
    setToInitialSegment() {
        if (this.initialSegment === this.dynamicSegment) {
            return;
        }
        this.dynamicSegment = this.initialSegment;
        this.activateSegmentButton();
    }
    handleButtonClick(segment) {
        if (segment === this.dynamicSegment) {
            return;
        }
        this.dynamicSegment = segment;
        this.activateSegmentButton();
    }
    redirectToSegment() {
        const url = new URL(window.location.href);
        const urlSegment = url.pathname.split('/')[1];
        this.$submitButton.on('click', ()=>{
            if (this.dynamicSegment === urlSegment) {
                this.$modal.addClass('hidden');
            } else {
                const url = `${this.baseUrl}/${this.dynamicSegment}${this._pathnameWithoutSegment}`;
                this.trackEvents();
                Turbolinks.visit(url);
            }
        });
    }
    trackEvents() {
        UserTracker.emit('event', {
            eventName: 'study segment changed',
            data: {
                'initial segment': segmentsName[this.initialSegment],
                'final segment': segmentsName[this.dynamicSegment]
            }
        });
    }
    constructor(component){
        this.baseUrl = this.setBaseUrl();
        this.initialSegment = this.hasSegment();
        this.dynamicSegment = this.hasSegment();
        this._pathnameWithoutSegment = this.pathnameWithoutSegment();
        this.component = component;
        this.$buttons = window.jQuery('#buttons-container button');
        this.$toogleModalButtons = window.jQuery('.js-toggle-modal');
        this.$submitButton = window.jQuery('#submit-button');
        this.$modal = window.jQuery('#js-handle-segment-modal');
        this.$segmentTitle = window.jQuery('#segment-title');
        this.init();
    }
}
const $components = window.jQuery('.js-handle-title-segment');
$components.each((i, component)=>new HandleTitleSegment(component));

// EXTERNAL MODULE: ./components/stripped_list/index.js + 1 modules
var stripped_list = __webpack_require__(65742);
// EXTERNAL MODULE: ./styles/components/_alerts.scss
var _alerts = __webpack_require__(39577);
// EXTERNAL MODULE: ./styles/components/_pagination.scss
var _pagination = __webpack_require__(17200);
;// CONCATENATED MODULE: ./pages/institutes/index.js









;// CONCATENATED MODULE: ./packs/institutes.js



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			2064: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [5280,1106,1642,6325,1636], () => (__webpack_require__(44823)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;